/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown>, time: NonNullable<unknown> }} Sidebar_Usage_TooltipInputs */



/**
* | output |
* | --- |
* | "{pct}% of today's allowance used · resets at {time}" |
*
* @param {Sidebar_Usage_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_usage_tooltip = /** @type {((inputs: Sidebar_Usage_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Usage_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.pct}% des heutigen Guthabens verbraucht · Reset um ${i?.time}`)
	return /** @type {LocalizedString} */ (`${i?.pct}% of today's allowance used · resets at ${i?.time}`)
});